// Configuration boutique (modifiable sans toucher au code)
// Numéro WhatsApp au format international SANS "+" ni espaces, ex : "221771234567".
// Laisser vide pour masquer le bouton WhatsApp.
export const WHATSAPP_NUMBER = "";
export const WHATSAPP_MESSAGE = "Bonjour ! J'ai une question sur un produit de Shopping en Chine.";
